import {
  FETCH_ALL_CATEGORIES_INIT,
  FETCH_ALL_CATEGORIES_SUCCESS,
  FETCH_ALL_CATEGORIES_FAILURE,
  FETCH_ALL_TAGS_BY_CATEGORY_INIT,
  FETCH_ALL_TAGS_BY_CATEGORY_SUCCESS,
  FETCH_ALL_TAGS_BY_CATEGORY_FAILURE,
  ACCOUNT_TAG_RESET_CATEGORY_TAGS,
  ACCOUNT_TAG_ADD_NEW_TAG_TO_SAVE_OR_DELETE,
  ACCOUNT_TAG_REMOVE_NEW_TAG_TO_SAVE_OR_DELETE,
  ACCOUNT_TAG_SAVE_TAGS_CHANGES_INIT,
  ACCOUNT_TAG_SAVE_TAGS_CHANGES_FAILURE,
  ACCOUNT_TAG_SAVE_TAGS_CHANGES_SUCCESS,
  RESET_ACCOUNT_TAG
} from './types';
import API from './api';

// Fetch all categories from the API
function fetchAllCategoriesInit() {
  return {
    type: FETCH_ALL_CATEGORIES_INIT
  };
}

function fetchAllCategoriesSuccess(data) {
  return {
    type: FETCH_ALL_CATEGORIES_SUCCESS,
    payload: data
  };
}

function fetchAllCategoriesFailure(error) {
  return {
    type: FETCH_ALL_CATEGORIES_FAILURE,
    payload: error
  };
}

export function getAllCategories(obj) {
  return async dispatch => {
    dispatch(fetchAllCategoriesInit());
    try {
      let data = await API.data.handleGetAllCategories(obj);
      dispatch(fetchAllCategoriesSuccess(data));
    } catch (error) {
      dispatch(fetchAllCategoriesFailure(error));
    }
  };
}

// Get tags by category
function fetchAllTagsByCategoryInit() {
  return {
    type: FETCH_ALL_TAGS_BY_CATEGORY_INIT
  };
}

function fetchAllTagsByCategorySucces(data,selectedCategory) {
  return {
    type: FETCH_ALL_TAGS_BY_CATEGORY_SUCCESS,
    payload: {
      data: data,
      selectedCategory: selectedCategory
    }
  };
}

function fetchAllTagsByCategoryFailure(error) {
  return {
    type: FETCH_ALL_TAGS_BY_CATEGORY_FAILURE,
    payload: error
  };
}

export function getAllTagsByCategory(categoryId, categoryName) {
  return async dispatch => {
    dispatch(fetchAllTagsByCategoryInit());
    try {
      let data = await API.data.handleGetAllTagsByCategory(categoryName);
      dispatch(fetchAllTagsByCategorySucces(
        data,
        {categoryId: categoryId, categoryName: categoryName}
      ));
    } catch (error) {
      dispatch(fetchAllTagsByCategoryFailure(error));
    }
  };
}

export function handleResetCategoryTags() {
  return dispatch => {
    return dispatch({
      type: ACCOUNT_TAG_RESET_CATEGORY_TAGS
    });
  };
}

/* Tag */
export function addNewTagToSaveOrDelete(item) {
  return dispatch => {
    return dispatch({
      type: ACCOUNT_TAG_ADD_NEW_TAG_TO_SAVE_OR_DELETE,
      payload: item
    });
  };
}

export function removeNewTagToSaveOrDelete(item) {
  return dispatch => {
    return dispatch({
      type: ACCOUNT_TAG_REMOVE_NEW_TAG_TO_SAVE_OR_DELETE,
      payload: item
    });
  };
}

function saveTagsChangesInit() {
  return {
    type: ACCOUNT_TAG_SAVE_TAGS_CHANGES_INIT
  };
}

function saveTagsChangesSuccess(data) {
  return {
    type: ACCOUNT_TAG_SAVE_TAGS_CHANGES_SUCCESS,
    payload: data
  };
}

function saveTagsChangesFailure(error) {
  return {
    type: ACCOUNT_TAG_SAVE_TAGS_CHANGES_FAILURE,
    payload: error
  };
}

export function saveTagsChanges(tags) {
  return async dispatch => {
    dispatch(saveTagsChangesInit());
    try {
      let data = await API.data.handleSaveTagsChanges(tags);
      dispatch(saveTagsChangesSuccess(data));
    } catch (error) {
      dispatch(saveTagsChangesFailure(error));
    }
  };
}

//reset
export function resetAccountTag() {
  return dispatch => {
    return dispatch({
      type: RESET_ACCOUNT_TAG
    });
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/account_tag/index.js